import { TENANT_MODULES } from '@/models/modules';
import store from '@/store/store';

export function tenantHasGonogoAccess() {
  const tenantModules = store.getters['tenantModules/tenantModules'];
  return tenantModules.includes(TENANT_MODULES.gonogo);
}

export function tenantHasDocumentsAccess() {
  const tenantModules = store.getters['tenantModules/tenantModules'];
  return tenantModules.includes(TENANT_MODULES.documents);
}

export function tenantHasOpportunitiesAccess() {
  const tenantModules = store.getters['tenantModules/tenantModules'];
  return tenantModules.includes(TENANT_MODULES.opportunities);
}

export function tenantHasPreProjectsAccess() {
  const tenantModules = store.getters['tenantModules/tenantModules'];
  return tenantModules.includes(TENANT_MODULES.pre_projects);
}

export function tenantHasLLMExtractionsAccess() {
  const tenantModules = store.getters['tenantModules/tenantModules'];
  return tenantModules.includes(TENANT_MODULES.llm_extractions) && tenantModules.includes(TENANT_MODULES.documents);
}

// deprecated - old BI module
export function tenantHasBiAccess() {
  const tenantModules = store.getters['tenantModules/tenantModules'];
  return tenantModules.includes(TENANT_MODULES.bi);
}

export function tenantHasBusinessIntelligenceAccess() {
  const tenantModules = store.getters['tenantModules/tenantModules'];
  return tenantModules.includes(TENANT_MODULES.business_intelligence);
}

export function tenantHasChromeExtensionAccess() {
  const tenantModules = store.getters['tenantModules/tenantModules'];
  return tenantModules.includes(TENANT_MODULES.chrome_extension);
}

export function tenantHasSlipExtractionAccess() {
  const tenantModules = store.getters['tenantModules/tenantModules'];
  return tenantModules.includes(TENANT_MODULES.slip_extraction);
}

export function tenantHasQuotesAccess() {
  const tenantModules = store.getters['tenantModules/tenantModules'];
  return tenantModules.includes(TENANT_MODULES.quotes);
}

export function tenantHasContactDirectoryAccess() {
  const tenantModules = store.getters['tenantModules/tenantModules'];
  return tenantModules.includes(TENANT_MODULES.contact_directory);
}

export function tenantHasTenderScoringAccess() {
  const tenantModules = store.getters['tenantModules/tenantModules'];
  return tenantModules.includes(TENANT_MODULES.tender_scoring);
}

export function tenantHasTasksAccess() {
  const tenantModules = store.getters['tenantModules/tenantModules'];
  return tenantModules.includes(TENANT_MODULES.tasks);
}

export function tenantHasFormFillingAccess() {
  const tenantModules = store.getters['tenantModules/tenantModules'];
  return tenantModules.includes(TENANT_MODULES.form_filling);
}
